/* Native upgrade disclosures. One open at a time on larger screens;
   handset starts collapsed, matching Mobile Clean. No animation dependency. */
(() => {
  'use strict';
  if (window.ZiloxDesktop) { window.ZiloxDesktop.refresh(); return; }
  const desktop = matchMedia('(min-width:768px)');
  const bound = new WeakSet();
  function upgradeGroups(root) {
    return [...(root.matches?.('.zd-upgrade-layout') ? [root] : []), ...root.querySelectorAll('.zd-upgrade-layout')];
  }
  function setInitial(group) {
    const items = [...group.querySelectorAll('[data-zd-upgrade]')];
    items.forEach((item, i) => {
      const summary = item.querySelector('summary');
      if (!(desktop.matches && i === 0) && item.contains(document.activeElement) && summary !== document.activeElement) summary?.focus({preventScroll:true});
      item.open = desktop.matches && i === 0; summary?.removeAttribute('tabindex');
    });
  }
  function revealHash() {
    let key;
    try { key = decodeURIComponent(location.hash.slice(1)); } catch { return; }
    if (!key) return;
    const target = document.getElementById(key);
    const item = target?.matches('[data-zd-upgrade]') ? target : target?.closest('[data-zd-upgrade]');
    if (item) {
      if (desktop.matches) item.closest('.zd-upgrade-layout')?.querySelectorAll('[data-zd-upgrade]').forEach(other => { if (other !== item) other.open = false; });
      item.open = true;
      requestAnimationFrame(() => item.scrollIntoView({behavior:'auto',block:'start'}));
    }
  }
  function refresh(root=document) {
    upgradeGroups(root).forEach(group => {
      if (bound.has(group)) return;
      bound.add(group); setInitial(group);
      group.addEventListener('click', e => {
        const summary = e.target.closest('summary');
        const item = summary?.parentElement;
        if (!desktop.matches || !item?.matches('[data-zd-upgrade]') || item.open) return;
        group.querySelectorAll('[data-zd-upgrade]').forEach(other => { if (other !== item) other.open = false; });
      });
    });
    revealHash();
  }
  const resized = () => { document.querySelectorAll('.zd-upgrade-layout').forEach(setInitial); revealHash(); };
  if (desktop.addEventListener) desktop.addEventListener('change', resized); else desktop.addListener(resized);
  document.addEventListener('shopify:section:load', e => refresh(e.target));
  window.addEventListener('hashchange', revealHash);
  window.ZiloxDesktop = {refresh};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => refresh(), {once:true}); else refresh();
})();
